import { Tier, BackrsUser, CareerTrack } from '@backrs_ui/common-ui';

import { CareerUserResponseSet, CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectUserSurveyResults } from '@backrs_ui/grow-ui/src/redux/userResponse/userResponse';
import { ScoreCalculationResult } from '@backrs_ui/grow-ui/src/utils/calculateSurveyResults';

type UseSurveyDataReturn = Readonly<{
  /** Whether the response set is currently loading */
  isLoadingResponseSet: boolean;
  /** The most recent user response set */
  mostRecentUserResponseSet: CareerUserResponseSet | null | undefined;
  /** The survey results including tier and career path suggestions */
  surveyResults:
    | {
        tier: Tier;
        careerPathSuggestions: CareerPathWithScore[];
        careerResults: ScoreCalculationResult;
      }
    | null
    | undefined;
  /** The current user */
  user: BackrsUser | null | undefined;
  /** Career path data from Redux state */
  careerPath: {
    careerTracks: CareerTrack[];
    loading?: boolean;
  };
}>;

export function useSurveyData(): UseSurveyDataReturn {
  const { mostRecentUserResponseSet, loadingMostRecentUserResponseSet } = useAppSelector(
    (state) => state.userResponseSet,
  );

  const surveyResults = useAppSelector((state) => selectUserSurveyResults(state));
  const user = useAppSelector((state) => state.user.user);

  const careerTracks = useAppSelector((state) => state.careerPath.careerTracks);
  const careerPathLoading = useAppSelector((state) => state.careerPath.loading);

  const isLoadingResponseSet =
    !surveyResults ||
    !mostRecentUserResponseSet ||
    (loadingMostRecentUserResponseSet && !!user?.access_token);

  return {
    isLoadingResponseSet,
    mostRecentUserResponseSet,
    surveyResults,
    user,
    careerPath: {
      careerTracks,
      loading: careerPathLoading,
    },
  };
}
